import { render, staticRenderFns } from "./createSmsTemplate.vue?vue&type=template&id=073b096a&scoped=true&"
import script from "./createSmsTemplate.vue?vue&type=script&lang=js&"
export * from "./createSmsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./createSmsTemplate.vue?vue&type=style&index=0&id=073b096a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b096a",
  null
  
)

export default component.exports